import { Injectable } from '@angular/core';
import { RenderedSection } from '../services/section-editor-bridge.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { Section } from '../editor-container/editor-model';

@Injectable({
  providedIn: 'root'
})
export class PreviewService {
  private sections$:BehaviorSubject<Section[]> = new BehaviorSubject<Section[]>(null)
  
  constructor() { }

  getBorderColors(el:Element){
    const styles = getComputedStyle(el);
    return {
      borderBasicColor1: styles.getPropertyValue('--border-basic-color-1'),
      borderBasicColor2: styles.getPropertyValue('--border-basic-color-2'),
      borderBasicColor3: styles.getPropertyValue('--border-basic-color-3'),
      borderBasicColor4: styles.getPropertyValue('--border-basic-color-4'),
      borderBasicColor5: styles.getPropertyValue('--border-basic-color-5'),
      borderPrimaryColor1: styles.getPropertyValue('--border-primary-color-1'),
      borderPrimaryColor2: styles.getPropertyValue('--border-primary-color-2'),
      borderPrimaryColor3: styles.getPropertyValue('--border-primary-color-3'),
      borderPrimaryColor4: styles.getPropertyValue('--border-primary-color-4'),
      borderPrimaryColor5: styles.getPropertyValue('--border-primary-color-5'),
      borderAlternativeColor1: styles.getPropertyValue('--border-alternative-color-1'),
      borderAlternativeColor2: styles.getPropertyValue('--border-alternative-color-2'),
      borderAlternativeColor3: styles.getPropertyValue('--border-alternative-color-3'),
      borderAlternativeColor4: styles.getPropertyValue('--border-alternative-color-4'),
      borderAlternativeColor5: styles.getPropertyValue('--border-alternative-color-5')
    }
    
  }

  getBackgrounds(el:Element){
    const styles = getComputedStyle(el);
    return {
      backgroundBasicColor1:styles.getPropertyValue('--background-basic-color-1'),
      backgroundBasicColor2:styles.getPropertyValue('--background-basic-color-2'),
      backgroundBasicColor3:styles.getPropertyValue('--background-basic-color-3'),
      backgroundBasicColor4:styles.getPropertyValue('--background-basic-color-4'),
      backgroundPrimaryColor1: styles.getPropertyValue('--background-primary-color-1'),
      backgroundPrimaryColor2: styles.getPropertyValue('--background-primary-color-2'),
      backgroundPrimaryColor3:styles.getPropertyValue('--background-primary-color-3'),
      backgroundPrimaryColor4: styles.getPropertyValue('--background-primary-color-4'),
      backgroundAlternativeColor1: styles.getPropertyValue('--background-alternative-color-1'),
      backgroundAlternativeColor2: styles.getPropertyValue('--background-alternative-color-2'),
      backgroundAlternativeColor3:styles.getPropertyValue('--background-alternative-color-3'),
      backgroundAlternativeColor4: styles.getPropertyValue('--background-alternative-color-4')
    }
  }

  getColorScheme(el:Element){
    const styles = getComputedStyle(el);
    return {
      primaryColor1:styles.getPropertyValue('--color-primary-100'),
      primaryColor2:styles.getPropertyValue('--color-primary-200'),
      primaryColor3:styles.getPropertyValue('--color-primary-300'),
      primaryColor4:styles.getPropertyValue('--color-primary-400'),
      primaryColor5: styles.getPropertyValue('--color-primary-500'),
      primaryColor6: styles.getPropertyValue('--color-primary-600'),
      primaryColor7:styles.getPropertyValue('--color-primary-700'),
      primaryColor8: styles.getPropertyValue('--color-primary-800'),
      primaryColor9: styles.getPropertyValue('--color-primary-800')
    }
  }

  getPageBackground(el:Element){
    const styles = getComputedStyle(el);
    //console.log(styles.getPropertyValue('--background-page-color'));
    //return styles.getPropertyValue('--background-page-color');
    return styles.getPropertyValue('--layout-background-color');
  }

  getFontFamilies(el:Element){
    const styles = getComputedStyle(el);
    return {
      primaryFontFam:styles.getPropertyValue('--font-family-primary'),
      secondaryFontFam:styles.getPropertyValue('--font-family-secondary')
    }
  }

  getLayoutTextColor(el:Element){
    const styles = getComputedStyle(el);
    return styles.getPropertyValue('--layout-text-color');
  }

  getSectionElements(el:Element):any[]{
    //console.log("Getting sectio elements")
    let renderedSections = [];
    let sectionElements = el.getElementsByTagName('kw-preview-section');
    if(sectionElements.length > 0){
      for(let i = 0;i < sectionElements.length;i++){
        //console.log(sectionElements[i].firstElementChild.getAttribute("renderer-type"));
        let sectionId = sectionElements[i].getAttribute("section-id");
        let rendererType = sectionElements[i].getAttribute('renderer-type');
        let elementId = rendererType+"-"+sectionId;
        let sectionElement:RenderedSection = {
          sectionId:sectionElements[i].getAttribute("section-id"),
          sectionIndex:i,
          rendererType:rendererType,
          elementId:elementId
        }
        //sectionElements[i].setAttribute("id",sectionElements[i].getAttribute("renderer-type")+"-"+sectionElements[i].getAttribute("section-id"))
        renderedSections.push(sectionElement);
      }
    }
    return renderedSections;
    //return sectionElements;

  }

  setSections(sections:Section[]):void{
    //console.log(sections)
    this.sections$.next(sections)
  }

  getSections():Observable<Section[]>{
    return this.sections$.asObservable()
  }
}


